/**
 * Плавающая кнопка «Тест» на главной (выбор варианта) — раскрывает заполнение тестовыми данными.
 */
import { useState } from 'react';
import { useWizardStore } from '../store/wizardStore';
import type { Variant } from '../types/wizard.types';

const TEST_VARIANTS: { id: Variant; label: string }[] = [
  { id: 'variant1', label: 'Вариант 1' },
  { id: 'variant2', label: 'Вариант 2' },
  { id: 'variant3', label: 'Вариант 3' },
];

export function TestModePanel() {
  const fillTestData = useWizardStore((s) => s.fillTestData);
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed left-4 bottom-4 z-40 flex flex-col items-start gap-2">
      {open && (
        <div className="flex flex-col gap-2 rounded-xl border border-amber-300 bg-white p-2 shadow-lg">
          {TEST_VARIANTS.map((v) => (
            <button
              key={v.id}
              type="button"
              onClick={() => {
                fillTestData(v.id);
                setOpen(false);
              }}
              className="text-sm px-4 py-2 rounded-lg border border-amber-300 bg-amber-50 text-amber-900 hover:bg-amber-100 transition whitespace-nowrap"
            >
              Тест — {v.label}
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="text-sm px-4 py-2 rounded-lg border border-amber-400 bg-amber-100 text-amber-900 hover:bg-amber-200 shadow-md transition"
        aria-expanded={open}
      >
        Тест
      </button>
    </div>
  );
}
